export default __webpack_public_path__ + "static/cool-3-d603c6ce1dee27f267cd12ec870b2900.svg";